import { render, staticRenderFns } from "./RtaDecision.vue?vue&type=template&id=984105ee&scoped=true"
import script from "./RtaDecision.vue?vue&type=script&lang=js"
export * from "./RtaDecision.vue?vue&type=script&lang=js"
import style0 from "./RtaDecision.vue?vue&type=style&index=0&id=984105ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984105ee",
  null
  
)

export default component.exports